module.exports = __webpack_public_path__ + "img/kajabi.f889e23f.svg";